import { gql } from "@apollo/client";

export const GET_LOGBOOKS = gql`
  query GetLogbooks($limit: Int = 10, $offset: Int = 10) {
    Logbook(offset: $offset, limit: $limit, where: { Active: { _eq: true } }) {
      Id
      created_at
      logbookTimeType
      logbookTitle
      logbookType
      updated_at
    }
    Logbook_aggregate(where: { Active: { _eq: true } }) {
      aggregate {
        count
      }
    }
  }
`;

export const INSERT_LOGBOOK = gql`
  mutation InsertLogbook(
    $BuildingId: uuid
    $logbookTimeType: String
    $logbookTitle: String
    $logbookItems: [LogbookItem_insert_input!]!
  ) {
    insert_Logbook(
      objects: {
        Active: true
        BuildingId: $BuildingId
        logbookTimeType: $logbookTimeType
        logbookTitle: $logbookTitle
        logbookType: "standard"
        LogbookItems: {
          on_conflict: {
            constraint: LogbookItem_pkey
            update_columns: [active, title, inputFieldType, isMandatory]
          }
          data: $logbookItems
        }
      }
      on_conflict: {
        constraint: Logbook_Id_key
        update_columns: [logbookTitle, logbookTimeType]
      }
    ) {
      affected_rows
    }
  }
`;
